import { type MouseEventHandler } from 'react';
import { hasKey } from 'dibs-ts-utils/exports/hasKey.ts';
import dibsCss from 'dibs-css';

export const TILE_SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xLarge: 'xLarge',
    xxLarge: 'xxLarge',
    auto: 'auto',
    autoImageLarge: 'autoImageLarge',
} as const;

// if change this, please also change /dibs-buyer-product-tile/src/styles/styles.scss
export const TILE_SIZES_PX = {
    small: 290,
    medium: 345,
    large: 405,
    xLarge: 445,
    xxLarge: 525,
} as const;

export type TileSize = (typeof TILE_SIZES)[keyof typeof TILE_SIZES];

const imageBackgroundColors = {
    white: dibsCss.bgWhite,
    moonStone: dibsCss.bgMoonstone,
} as const;

export type ImageBackgroundColor = keyof typeof imageBackgroundColors;
export type ImageBackgroundColorValue = (typeof imageBackgroundColors)[ImageBackgroundColor];

export const getBackgroundColor = (
    imageBackgroundColor: ImageBackgroundColor | null | undefined
): ImageBackgroundColorValue | undefined =>
    imageBackgroundColor && hasKey(imageBackgroundColors, imageBackgroundColor)
        ? imageBackgroundColors[imageBackgroundColor]
        : undefined;

export type SrcSet = {
    sizes?: string;
    widths?: number[];
    quality?: number;
};

export const SRC_SET_SIZES_TILE = '(max-width:768px) 50vw, (max-width:1024px) 33vw, 25vw';

export type OnClick = MouseEventHandler<HTMLElement>;
